import type { IconName } from '../../icons/types';
export type ValidationType = 'error' | 'success';

type ValidationIconEntry = {
  inlineIcon: IconName;
  messageIcon: IconName;
};

export const VALIDATION_CONFIG: Record<ValidationType, ValidationIconEntry> = {
  error: {
    inlineIcon: 'caution-outline',
    messageIcon: 'caution-fill-sm',
  },
  success: {
    inlineIcon: 'check-circle-outline',
    messageIcon: 'check-circle-fill-sm',
  },
};
